import classNames from 'classnames';
import { PropsWithChildren } from 'react';

interface PageHeadingProps extends PropsWithChildren {
  className?: string;
}

function PageHeading({ className, children }: PageHeadingProps) {
  return (
    <h1 className={classNames('pb-10 text-4xl font-semibold', className)}>
      {children}
    </h1>
  );
}

export default PageHeading;
